import React, { Component } from 'react';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import SelectBox from '../../../shared/components/presentation/select-box/SelectBox';
import './CrcCalculator.css';
import getData from '../../../shared/functions/getData';
import roundNumber from '../../../shared/functions/roundNumber';

export class CrcCalculatorContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activity: {
        text: null
      },
      activities: [],
      activitiesText: [],
      gender: "male",
      intensity: '4.74',
      submittedIntensity: '4.74',
      submitErrorMessage: "",
      errorMessages: {
        height: '',
        weight: '',
        activity: '',
        weightLoss: ''
      },
      calculatedCalories: 0,
      sameAsActivity: [{
        name: '',
        value: ''
      }],
      calculatedRange: {
        min: 'Up',
        max: '--'
      },
      energyEquivalents: {
        min: 0,
        optimal: 0
      },
      weightLossGoals: {
        bmi: 0,
        bodySizeCategory: "",
        goalAndIdealComparisonText: "equivalent to what",
        newBmi: 0,
        newBodySizeCategory: "",
        newWeight: 0,
        totalWeightLoss: 0,
        totalMonths: 0,
        weightLossGoal: 0
      }
    }
    
    this.intensityLevels = [{
      name: 'Low',
      description: 'Basic activities of daily living, no problems carrying on a conversation. (MET value less than 3; RPE <9)',
      rangeMultipliers: {
        min: 0,
        max: 0.56
      },
      physicalActivityRecs: {
        min: {
          minutesPerWeek: 150
        },
        optimal: {
          minutesPerWeek: 300
        }
      },
      value: '4.74'
    },
    {
      name: 'Low-to-Moderate',
      description: 'Activities of daily living requiring slightly more effort such as yard work and raking leaves, little difficulty talking. (RPE = 9-11)',
      rangeMultipliers: {
        min: 0.57,
        max: 0.63
      },
      physicalActivityRecs: {
        min: {
          minutesPerWeek: 150
        },
        optimal: {
          minutesPerWeek: 300
        }
      },
      value: '4.8'
    },
    {
      name: 'Moderate',
      description: 'Dedicated walking, can talk but it takes some effort. (MET value 3 to 5.9; RPE = 12-13)',
      rangeMultipliers: {
        min: 0.64,
        max: 0.76
      },
      physicalActivityRecs: {
        min: {
          minutesPerWeek: 150
        },
        optimal: {
          minutesPerWeek: 300
        }
      },
      value: '4.86'
    },
    {
      name: 'Moderate-to-Hard',
      description: 'Fast-paced, brisk walk (up to a jog), can talk but it takes more effort. (RPE = 14-15)',
      rangeMultipliers: {
        min: 0.77,
        max: 0.84
      },
      physicalActivityRecs: {
        min: {
          minutesPerWeek: 150
        },
        optimal: {
          minutesPerWeek: 300
        }
      },
      value: '4.92'
    },
    {
      name: 'Hard-to-Vigorous',
      description: 'Vigorous activity such as jogging and running combination, takes a lot of effort to talk. (MET value greater than 6; RPE = 16-18)',
      rangeMultipliers: {
        min: 0.85,
        max: 0.95
      },
      physicalActivityRecs: {
        min: {
          minutesPerWeek: 75
        },
        optimal: {
          minutesPerWeek: 150
        }
      },
      value: '4.99'
    }];

    this.intensityLevelsRadioList = this.intensityLevels.map((level) => {
      return {
        checked: false,
        id: level.value,
        label: `${level.name}: ${level.description}`,
        value: level.value
      };
    });

    this.disclaimer = <div className="disclaimer field">
      <strong>Disclaimer:</strong> Please note that we cannot provide treatment recommendations nor diagnose your condition. The Heart Activity Calculator is NOT intended to replace the medical advice, treatment or diagnosis of your physician or health care provider. Please consult your health care provider for advice about a specific medical condition. The Heart Activity Calculator must be considered at all times as an educational, convenience service only and shall not be relied upon nor designed to replace or substitute a physician's independent judgment about the appropriateness or risks of a procedure for a given patient. Cleveland Clinic does not endorse, guarantee the accuracy, adequacy, completeness or availability of any information and is not responsible for any errors or omissions or for the results obtained from the use of this service. Cleveland Clinic does not guarantee the availability or ability to use this service.
    </div>;
  }

  // load activity data
  componentDidMount() {
    this.activitiesText = [];

    getData('./activity_mets.json').then((activityData) => {
      for (let activity of activityData) {
        this.activitiesText.push(activity['Category'] + ' - ' + activity['Description']);
      }
      this.setState({ activities: activityData, activitiesText: this.activitiesText });
    })
  }

  handleActivityChange(event) {
    let activityObj = this.state.activities.find(activity => activity['Category'] + ' - ' + activity['Description'] === event) || { text: null }
    this.setState({ activity: activityObj });
  }

  handleIntensityChange(event, value) {
    this.setState({ intensity: value });
  }

  handleGenderChange(event, value) {
    this.setState({ gender: value });
  }

  // Returning height value
  computeHeight(feet, inches) {
    return ((feet * 12) + (inches || 0)) * 2.54;
  }

  // Building activity data for the select
  buildSameAsActivitySelect(METsValue) {
    const comparison = 1;
    let filteredActivities = this.state.activities.filter(activity => {
      // if mets values are equal, + or - 1, and not the currently selected val
      return (Math.abs(activity["METs"] - METsValue) <= comparison)
        && (activity["Category"] + ' - ' + activity["Description"]) !== (this.state.activity["Category"] + ' - ' + this.state.activity["Description"])
    })

    let mappedActivities = filteredActivities.map(activity => {
      return { name: activity["Category"] + ' - ' + activity["Description"], value: activity["Category"] + ' - ' + activity["Description"] };
    });
    this.setState({ sameAsActivity: mappedActivities })
  }

  buildErrors(submitEvent, valuesObj) {
    if (valuesObj.duration < 1 || isNaN(valuesObj.duration)) {
      submitEvent.errors.push('Duration is required')
    }
    if ((isNaN(valuesObj.feet) && isNaN(valuesObj.inches)) || (valuesObj.feet < 1 && valuesObj.inches < 1)) {
      submitEvent.errors.push('Height is required')
    }
    let errorMessages = {};
    submitEvent.errors.forEach(error => {
      errorMessages[`${error.split(' ')[0]}`] = error;
    });
    this.setState({ errorMessages });
  }

  handleSubmit(event) {
    const calculationValues = {
      activity: event.values.activity,
      feet: parseInt(event.values['height-feet-input'], 10) || 0,
      inches: parseInt(event.values['height-inches-input'], 10) || 0,
      weight: parseInt(event.values['weight-input'], 10),
      gender: event.values['gender-radio-list'],
      age: event.values['age-input'],
      weightLoss: parseInt(event.values['weight-loss-input'], 10) || 0,
      duration: (Number(event.values['duration-hours-input']) * 60) + Number(event.values['duration-minutes-input']),
      intensity: Number(event.values['intensity'])
    }

    this.buildErrors(event, calculationValues);

    if (event.errors.length < 1) {
      this.calculateHR(calculationValues);
      const totalCalories = roundNumber(this.calculateCalories(calculationValues));
      const energyEquivalents = this.calculateEnergyEquivalents(calculationValues);
      const weightLossGoals = this.calculateWeightLossGoals(calculationValues);
      
      this.setState({ 
        calculatedCalories: totalCalories, 
        energyEquivalents,
        submitErrorMessage: "", 
        submittedIntensity: event.values['intensity'],
        weightLossGoals
      });
    }
    else {
      this.setState({ submitErrorMessage: "Please fill out the missing fields" });
    }
  }

  calculateHR(values) {
    const peakExerciseHeartRate = 208 - (0.7 * values.age); 
    
    let intensityLevelObject = this.intensityLevels.find((level) => level.value === values.intensity.toString());
    
    let calculatedRange = {
      min: roundNumber(peakExerciseHeartRate * intensityLevelObject.rangeMultipliers.min),
      max: roundNumber(peakExerciseHeartRate * intensityLevelObject.rangeMultipliers.max)
    };
    
    this.setState({ calculatedRange });
  }

  calculateCalories(values, durationOverride) {
    // values from form inputs
    const height = this.computeHeight(values.feet, values.inches);
    const weight = values.weight / 2.2046;
    const gender = (values.gender === 'female') ? -161 : 5;
    const dietModifier = 4.73;
    let { activity, duration, intensity } = values;
    if (durationOverride) {
      duration = durationOverride;
    }

    // get activity
    const activityObjFromValue = this.state.activities.find(activityObj => activityObj["Category"] + ' - ' + activityObj["Description"] === activity) || {};

    // compute
    const predictedDailyCal = (9.99 * weight + 6.25 * height - 4.92 + gender);
    const predictedRMR = predictedDailyCal / 1440 / dietModifier / weight * 1000;
    const METs = activityObjFromValue.METs;
    const correctedMET = METs * 3.5 / predictedRMR;
    const caloriesPerMinute = correctedMET * predictedRMR * weight / 1000;

    this.buildSameAsActivitySelect(METs);

    return caloriesPerMinute * intensity * duration;
  }
  
  calculateEnergyEquivalents = (values) => {
    let chosenIntensity = this.intensityLevels.find((level) => level.value === values.intensity.toString());
    let minDuration = chosenIntensity.physicalActivityRecs.min.minutesPerWeek / 3;
    let optimalDuration = chosenIntensity.physicalActivityRecs.optimal.minutesPerWeek / 6;
    
    let min = roundNumber((this.calculateCalories(values, minDuration) * 12 / 3500), 1);
    let optimal = roundNumber((this.calculateCalories(values, optimalDuration) * 24 / 3500), 1);
    
    return { min, optimal };
  }
  
  calculateWeightLossGoals = (values) => {
    const kgWeight = values.weight / 2.2046;
    const cmHeight = this.computeHeight(values.feet, values.inches);
    const kgWeightLoss = values.weightLoss / 2.2046;
    const lbWeightLoss = values.weightLoss;
    
    const bmi = this.calculateBmi(kgWeight, cmHeight);
    let bodySizeCategory = this.getBodySizeCategory(bmi);
    const newBmi = this.calculateBmi(kgWeight - kgWeightLoss, cmHeight);
    let newBodySizeCategory = this.getBodySizeCategory(newBmi);
    let normalWeight = roundNumber(this.calculateLbNormalWeight(cmHeight), 1);
    let kgTotalWeightLoss = kgWeight - (normalWeight / 2.2046);
    kgTotalWeightLoss = (kgTotalWeightLoss > 0) ? kgTotalWeightLoss : 0;
    let lbTotalWeightLoss = roundNumber((kgTotalWeightLoss * 2.2046), 1);
    let newWeight = values.weight - values.weightLoss;
    let goalAndIdealComparisonText;
    
    switch (true) {
      case (newWeight > normalWeight):
        goalAndIdealComparisonText = "less than";
        break;
      case (newWeight < normalWeight):
        goalAndIdealComparisonText = "more than";
        break;
      default:
        goalAndIdealComparisonText = "equivalent to what";
        break;
    }
    
    return {
      bmi,
      bodySizeCategory,
      goalAndIdealComparisonText,
      newBmi,
      newBodySizeCategory,
      newWeight,
      normalWeight,
      totalWeightLoss: lbTotalWeightLoss,
      totalMonths: roundNumber((lbTotalWeightLoss / 4), 1),
      weightLossGoal: lbWeightLoss
    };
  }
  
  calculateBmi = (kgWeight, cmHeight) => {
    return roundNumber((kgWeight / Math.pow((cmHeight / 100), 2)), 1);
  }
  
  getBodySizeCategory = (bmi) => {
    switch (true) {
      case (bmi < 18.5):
        return "Underweight";
      case (bmi < 25):
        return "Normal weight";
      case (bmi < 30):
        return "Overweight";
      case (bmi < 35):
        return "Obesity Class I";
      case (bmi < 40):
        return "Obesity Class II";
      default:
        return "Extreme Obesity";
    }
  }
  
  calculateLbNormalWeight = (cmHeight) => {
    return (2.2 * 24.99 + 3.5 * 24.99 * ((cmHeight / 100) - 1.5)) * 2.2;
  }

  render() {
    const arrayOfInputs = [
      {
        type: 'static',
        content: <h3>Step 1: Your Information</h3>
      },
      {
        legend: 'Gender',
        id: 'gender-radio-list',
        type: 'radio-list',
        groupName: 'Gender',
        className: 'fields-inline',
        onChange: (event, value) => this.handleGenderChange(event, value),
        selectedId: this.state.gender,
        radioProps: [{
          checked: false,
          id: 'male',
          label: 'Male',
          value: 'male',
        },
        {
          checked: false,
          id: 'female',
          label: 'Female',
          value: 'female',
        }]
      },
      {
        fieldsetLegend: "Height",
        fieldsetColumns: 2,
        className: 'fields-inline',
        required: true,
        inputs: [
          {
            id: 'height-feet-input',
            type: 'number',
            numberMin: '0',
            className: 'field__large',
            errorMessage: this.state.errorMessages.Height,
            infoText: 'feet'
          },
          {
            id: 'height-inches-input',
            type: 'number',
            numberMin: '0',
            className: 'field__large',
            infoText: 'inches'
          }
        ]
      },
      {
        label: "Weight",
        required: true,
        id: 'weight-input',
        type: 'number',
        numberMin: '0',
        className: 'field__small',
        errorMessage: this.state.errorMessages.Weight,
        infoText: 'pounds'
      },
      {
        label: "Age",
        required: true,
        id: 'age-input',
        type: 'number',
        numberMin: '0',
        className: 'field__small',
        errorMessage: this.state.errorMessages.Age,
        infoText: 'years'
      },
      {
        type: 'static',
        content: <h3>Step 2: What are your weight loss goals?</h3>
      },
      {
        label: "How Much Weight Do You Want to Lose?",
        required: false,
        id: 'weight-loss-input',
        type: 'number',
        numberMin: '0',
        className: 'field__small',
        errorMessage: this.state.errorMessages.WeightLoss,
        infoText: 'pounds'
      },
      {
        type: 'static',
        content: <h3>Step 3: What activity did you do today?</h3>
      },
      {
        type: 'typeahead',
        id: 'activity',
        label: 'Activity',
        required: true,
        className: "",
        errorMessage: this.state.errorMessages.Activity,
        onChange: (event) => this.handleActivityChange(event),
        isEditable: true,
        options: this.state.activitiesText,
        placeholderText: 'Enter an activity',
        hasListAllView: true
      },
      {
        fieldsetLegend: "How long would you like to exercise?",
        fieldsetColumns: 2,
        className: 'fields-inline',
        required: true,
        inputs: [
          {
            id: 'duration-hours-input',
            type: 'number',
            numberMax: '9',
            numberMin: '0',
            className: 'field__large',
            errorMessage: this.state.errorMessages.Duration,
            infoText: 'hours'
          },
          {
            id: 'duration-minutes-input',
            type: 'number',
            numberMin: '0',
            className: 'field__large',
            infoText: 'minutes'
          }
        ]
      },
      {
        type: 'radio-list',
        id: 'intensity',
        legend: 'Intensity Level',
        groupName: "Intensity Level",
        selectedId: this.state.intensity,
        onChange: (event, value) => this.handleIntensityChange(event, value),
        radioProps: this.intensityLevelsRadioList,
      },
      {
        type: 'static',
        content: this.disclaimer
      },
      {
        type: "submit",
        value: "Calculate",
        errorMessage: this.state.submitErrorMessage
      }
    ];

    let chosenIntensity = this.intensityLevels.find((level) => level.value === this.state.submittedIntensity);
    
    let threeDayWeightLoss = roundNumber((this.state.calculatedCalories * 3 / 3500), 1);
    
    let sixDayWeightLoss = roundNumber((this.state.calculatedCalories * 6 / 3500), 1);
    
    const trainingZoneRecs = <React.Fragment>
      <h5>Exercise Heart Rate Training Zone Recommendations</h5>
      <p>Based on your current age and taking no other medical history, medications or other personal information into account:</p>
      <ul>
        <li>
          Chosen exercise intensity: {(chosenIntensity) ? chosenIntensity.name : ""}
        </li>
        <li>
          Recommended exercise training target heart rate range: {(this.state.calculatedRange.min) ? this.state.calculatedRange.min : "Up"} to {(this.state.calculatedRange.max) ? this.state.calculatedRange.max : "--"} beats per minute
        </li>
        <li>
          Exercise Rating of Perceived Exertion (RPE): The RPE scale is a subjective way to measure the intensity of your exercise. This is quantified using a 6 to 20 scale representing how easy or difficult you find an activity where 6 is “very, very light”; 15-18 is “hard to vigorous”; and 19-20 is “near maximal”.
        </li>
      </ul>
    </React.Fragment>;
    
    const physicalActivityRecs = <React.Fragment>
      <h5>Physical Activity Program Recommendations</h5>
      <p>Based on your current age, body size, gender, and prevention goals, including weight loss and exercise interests:</p>
      <em>Minimum Recommendations</em>
      <ul>
        <li>Exercise Frequency: 3 days of the week</li>
        <li>
          Chosen exercise intensity: {(chosenIntensity) ? chosenIntensity.name : ""}
        </li>
        <li>Total time per week: {`${chosenIntensity.physicalActivityRecs.min.minutesPerWeek} minutes`}</li>
        <li>Total time per day: {`${chosenIntensity.physicalActivityRecs.min.minutesPerWeek / 3} minutes, completed all at once or in small amounts.`}</li>
        <li>Following this plan, you will have lost {this.state.energyEquivalents.min} lbs over 1 month, not accounting for diet. (Are you eating a heart healthy diet? Find out how you rate with our <a href="https://health.clevelandclinic.org/are-you-eating-a-mediterranean-diet/" target="_blank">Mediterranean Diet</a> and <a href="https://health.clevelandclinic.org/are-you-eating-the-dash-diet/" target="_blank">DASH Diet</a> quizzes.)</li>
      </ul>
      <em>Optimal Recommendations</em>
      <ul>
        <li>Exercise Frequency: 6 days of the week</li>
        <li>
          Chosen exercise intensity: {(chosenIntensity) ? chosenIntensity.name : ""}
        </li>
        <li>Total time per week: {`${chosenIntensity.physicalActivityRecs.optimal.minutesPerWeek} minutes`}</li>
        <li>Total time per day: {`${chosenIntensity.physicalActivityRecs.optimal.minutesPerWeek / 6} minutes, completed all at once or in small amounts.`}</li>
        <li>Following this plan, you will have lost {this.state.energyEquivalents.optimal} lbs over 1 month, not accounting for diet. (Are you eating a heart healthy diet? Find out how you rate with our <a href="https://health.clevelandclinic.org/are-you-eating-a-mediterranean-diet/" target="_blank">Mediterranean Diet</a> and <a href="https://health.clevelandclinic.org/are-you-eating-the-dash-diet/" target="_blank">DASH Diet</a> quizzes.)</li>
      </ul>
      <strong>Did you know?</strong>
      <p>All physical activity counts, even as little as five minutes at a time. Your participation in physical activity produces immediate health benefits, at any age. These benefits can include:</p>
      <ul>
        <li>Improved sleep quality</li>
        <li>Reduced anxiety</li>
        <li>Lower blood pressure</li>
        <li>Improved insulin sensitivity</li>
      </ul>
      <p>When your physical activity is regular on a long-term basis, you can expect even greater and lasting benefits for your heart and overall health. Plus, exercising regularly improves your physical fitness, which can even translate into living a longer life.</p>
      <p>Want to learn even more? Visit our <a href="https://health.clevelandclinic.org/how-to-get-started-on-your-cardiac-rehab-program-%E2%80%95-and-get-your-heart-healthy-again/" target="_blank">Cardiac Prevention and Rehabilitation experience.</a></p>
    </React.Fragment>;
      
    const weightLossGoals = <React.Fragment>
      <h5>Weight Loss Goals</h5>
      <p>
        Given the information you provided, your BMI information is:
      </p>
      <ul>
        <li>BMI: {this.state.weightLossGoals.bmi}</li>
        <li>Body Size Category: {this.state.weightLossGoals.bodySizeCategory}</li>
      </ul>  
      {
        (this.state.weightLossGoals.bodySizeCategory === "Underweight") ?
          <p>Any additional weight loss is not recommended. We recommend that you speak with your Primary Care Physician or other qualified healthcare professional to identify what is an appropriate body weight for you.</p> :
          <React.Fragment>
            <p>
              Based on information you provided, the ideal weight for you is: {this.state.weightLossGoals.normalWeight} lbs.
            </p>
            <ul>
              {
                (!this.state.weightLossGoals.totalWeightLoss) ?
                  <li>You are already within the normal weight range.</li> :
                  <React.Fragment>
                    <li>Total weight loss needed to achieve ideal weight: {this.state.weightLossGoals.totalWeightLoss} lbs</li>
                    <li>Total months needed to achieve ideal weight: {this.state.weightLossGoals.totalMonths}</li>
                    <li>Body Size Category: Normal weight</li>
                  </React.Fragment>
              }
            </ul>
            {
              (this.state.weightLossGoals.newBmi !== this.state.weightLossGoals.bmi) ?
                <React.Fragment>
                  <p>
                    Based on the amount of desired weight loss entered above, your new body weight and BMI will be:
                  </p>
                  <ul>
                    <li>Body Weight: {this.state.weightLossGoals.newWeight} lbs</li>
                    <li>BMI: {this.state.weightLossGoals.newBmi}</li>
                    <li>Body Size Category: {this.state.weightLossGoals.newBodySizeCategory}</li>
                    <li>Your weight loss goal is {this.state.weightLossGoals.goalAndIdealComparisonText} is needed to achieve your ideal weight</li>
                  </ul>
                </React.Fragment> :
                null
            }
          </React.Fragment>
      }
      <strong>Did you know?</strong>
      <ul>
        { 
          (this.state.weightLossGoals.bodySizeCategory !== "Underweight") ?
            <li>
              1 lb equals 3,500 calories. Therefore, by performing your chosen exercise:
              <ul>
                <li>3 days out of the week, you will have lost {threeDayWeightLoss} lbs (not accounting for diet).</li>
                <li>6 days out of the week, you will have lost {sixDayWeightLoss} lbs (not accounting for diet).</li>
                <li>{roundNumber(sixDayWeightLoss - threeDayWeightLoss, 1)} lbs = Difference in weight loss in lbs per week by performing your chosen exercise alone between the minimum of 3 days compared with an optimal 6 days equals (not accounting for diet). The benefits of controlled exercise combined with healthy weight loss and management improve when practiced on a consistent basis at higher levels of frequency.</li>
              </ul>
            </li> :
            null
        }
        <li>How is BMI calculated? Learn more about <a href="https://my.clevelandclinic.org/health/articles/9464-body-mass-index-bmi" target="_blank">Body Mass Index (BMI).</a></li>
      </ul>
    </React.Fragment>;
        
    const thePower = <React.Fragment>
      <h5>You have the power!</h5>
      <p>Lowering your BMI number is possible by consistently making heart healthy choices. This should collectively involve regular participation in physical activity and exercise, practicing portion control, and limiting the amount of saturated fat, sugar, salt, and processed foods you eat.</p>
      <p>BMI should not be used to diagnose body fatness or health of an individual. However, for certain individuals, a high BMI can be useful as a screening tool to indicate if there is a need to discuss with a healthcare professional what level of cardiovascular health risk is associated with your number.</p>
    </React.Fragment>;
    
    const references = <div className="references">
      <hr />
      <p>References for Heart Activity Health:</p>
      <ul>
        <li>Ainsworth, B. E., et al. (2011). "2011 Compendium of Physical Activities: a second update of codes and
          MET values." Med Sci Sports Exerc 43(8): 1575-1581.</li>
        <li>Frankenfield, D., et al. (2005). "Comparison of predictive equations for resting metabolic rate in healthy
          nonobese and obese adults: a systematic review." J Am Diet Assoc 105(5): 775-789.</li>
        <li>Franklin, B. A., et al. (1983). "Metabolic cost of extremely slow walking in cardiac patients: implications
          for exercise testing and training." Arch Phys Med Rehabil 64(11): 564-565.</li>
        <li>Lagerros, Y. T. and P. Lagiou (2007). "Assessment of physical activity and energy expenditure in epidemiological
          research of chronic diseases." European Journal of Epidemiology 22(6): 353-362.</li>
        <li>Mifflin, M. D., et al. (1990). "A new predictive equation for resting energy expenditure in healthy individuals."
          The American journal of clinical nutrition 51(2): 241-247.</li>
        <li>Piercy, K. L., et al. (2018). "The Physical Activity Guidelines for Americans." Jama 320(19): 2020-2028.</li>
      </ul>
      <p>References for Weight Loss Goals:</p>
      <ul>
        <li>U. S. Preventive Services Task Force. Behavioral weight loss interventions to prevent obesity-related morbidity and mortality in adults: Us preventive services task force recommendation statement." Jama 320(11): 1163-1171.</li>
        <li>Batsis, J. A., et al. (2017). "Weight loss interventions in older adults with obesity: a systematic review of randomized controlled trials since 2005." Journal of the American Geriatrics Society 65(2): 257-268.</li>
        <li>Villareal, D. T., et al. (2017). "Aerobic or resistance exercise, or both, in dieting obese older adults." New England Journal of Medicine 376(20): 1943-1955.</li>
        <li>Bray, G. A., et al. (2016). "Management of obesity." The Lancet 387(10031): 1947-1956.</li>
        <li>Hales, C. M., et al. (2018). "Differences in obesity prevalence by demographic characteristics and urbanization level among adults in the United States, 2013-2016." Jama 319(23): 2419-2429.</li>
        <li>Ogden, C. L., et al. (2014). "Prevalence of childhood and adult obesity in the United States, 2011-2012." Jama 311(8): 806-814.</li>
        <li>Sun, Q. et al., 2010. Comparison of dual-energy x-ray absorptiometric and anthropometric measures of adiposity in relation to adiposity-related biologic factors. Am. J. Epidemiol., 172(12), pp.1442–1454.</li>
        <li>Flegal, K.M. & Graubard, B.I., 2009. Estimates of excess deaths associated with body mass index and other anthropometric variables. Am. J. Clin. Nutr., 89(4), pp.1213–1219.</li>
      </ul>
    </div>;
    
    const closing = <div className="crc-results-panel__closing">
      {trainingZoneRecs}
      {physicalActivityRecs}
      {weightLossGoals}
      {thePower}
      {references}
    </div>;

    let displayCalculationMessage;

    if (this.state.sameAsActivity.length > 0) {
      displayCalculationMessage = (this.state.calculatedCalories > 0) ?
        (
          <div className="crc-results-panel">
            <p className="crc-results-panel__header">You burned <strong>{this.state.calculatedCalories}</strong> calories. That's the same as</p>
            <div className="crc-results-panel__select">
              <SelectBox
                options={this.state.sameAsActivity}
                id="crc-results-select" />
            </div>
            <p className="crc-results-panel__duration">for the same amount of time.</p>
            {closing}
          </div>
        ) :
        null;
    }
    else {
      displayCalculationMessage = (this.state.calculatedCalories > 0) ?
        (
          <div className="crc-results-panel">
            <p className="crc-results-panel__header">You burned <strong>{this.state.calculatedCalories}</strong> calories.</p>
            {closing}
          </div>
        ) :
        null;
    }

    return (
      <div className="crc-calculator-container">
        <InputList
          isNestedGrid={true}
          inputs={arrayOfInputs}
          onSubmit={(values) => this.handleSubmit(values)}
          formId="crc-form" />
        {displayCalculationMessage}
      </div>
    );
  }
}

// connects component to redux, and passes along the router
export default CrcCalculatorContainer;



// WEBPACK FOOTER //
// ./src/crc/components/crc-calculator/CrcCalculator.js